import styles from './Search.module.scss';

export default function Loader() {
  return <div className={styles.Loader} />;
}
